import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import StarburstDecor from '../ui/StarburstDecor';

const HeroSection = () => {
  return (
    <section className="relative bg-white overflow-hidden py-8">
      <div className="container-main">
        <div className="grid lg:grid-cols-2 gap-8 items-start">
          {/* Left Side - Text and Image */}
          <div className="relative">
            {/* Hero Headlines */}
            <div className="mb-6">
              <h1 className="font-display font-bold leading-none">
                <span className="text-lime text-5xl md:text-6xl lg:text-7xl italic">CREATIVE</span>
                <br />
                <span className="text-navy text-5xl md:text-6xl lg:text-7xl">DIGITAL</span>
                <br />
                <span className="text-navy text-5xl md:text-6xl lg:text-7xl">AGENCY</span>
              </h1>
            </div>

            {/* Hero Image - App mockup */}
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-gradient-to-br from-indigo-600 via-purple-600 to-blue-500">
              <img
                src="https://images.unsplash.com/photo-1581287053822-fd7bf4f4bfec?w=800&q=80"
                alt="App Design"
                className="w-full h-full object-cover mix-blend-overlay"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/80 via-purple-600/80 to-blue-500/80" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="grid grid-cols-3 gap-4 p-8">
                  {[1,2,3,4,5,6].map((i) => (
                    <div key={i} className="w-16 h-16 md:w-20 md:h-20 bg-white/20 rounded-2xl backdrop-blur-sm" />
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Second Image and Text */}
          <div className="relative">
            {/* Starburst decoration */}
            <div className="absolute -top-4 right-0 z-10">
              <StarburstDecor size={120} color="lime" />
            </div>

            {/* Description text */}
            <div className="mb-6 pt-4">
              <p className="text-gray-600 text-lg leading-relaxed max-w-md">
                <span className="font-semibold text-navy">Product research</span> is all about one potential of turning challenges into opportunities.
              </p>
            </div>

            {/* Second Hero Image */}
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-navy">
              <img
                src="https://images.unsplash.com/photo-1627542557169-5ed71c66ed85?w=800&q=80"
                alt="Job Search App"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-navy/60" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/10 backdrop-blur-md rounded-xl p-4">
                  <p className="text-white text-sm">Mobile App Design</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
